/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import useMedia from './use-media';
export default (function () {
  return useMedia({
    queries: ['(orientation:portrait)', '(orientation:landscape)'],
    values: ['portrait', 'landscape'],
    defaultValue: 'portrait'
  });
});